import { useQuery } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse/types'
import { getRatingMetrics, RatingMetrics } from 'api/pulse/ratingMetrics'
import { getRatingMetricsKey } from 'queries/pulse/keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useRatingMetrics(query: PulseFilters) {
  return useQuery<RatingMetrics>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getRatingMetricsKey(query),
    queryFn: ({ signal }) => getRatingMetrics(query, signal),
    enabled: !!query.companyIds?.length,
  })
}
